var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "list",
    alias: "array",
    title: "List",
    description: "A field that accepts a list of values, validated by a defined type.",
    type: "field",
    use: {
        namespace: "ua.array"
    },
    fields: {
        of: {
            title: "Item Type",
            type: "string"
        }
    },
    tests: {
        valid: {
            must: true,
            run: function () {
                return validate({ type: "list", of: "string" }, ["one", "two"]);
            }
        },
        empty: {
            throw: "fields.list.empty",
            run: function () {
                return validate({ type: "list", of: "string", required: true }, []);
            }
        },
        invalidItem: {
            throw: "fields.list.invalidItem",
            run: function () {
                return validate({ type: "list", of: "number" }, [1, 2, "three"]);
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid List",
            description: "Value must be an array.",
            template: "Expected array, got ${typeof}"
        },
        empty: {
            title: "Empty List",
            description: "The list is empty but required.",
            template: "A non-empty list was expected."
        },
        invalidItem: {
            title: "Invalid List Item",
            description: "One or more items in the list failed validation.",
            template: "Invalid item in list: ${item}"
        },
        missingOf: {
            title: "Missing Item Type",
            description: "The 'of' field is required to specify the type of items in the list."
        }
    }
});

var myManager = require("../uam/fields.js");

// var myManager = false;

function init() {
    if (myManager) return;
    myManager = require("../uam/fields.js");
}

function validate(spec, value) {

    init();

    if (!Array.isArray(value)) {
        _.errors.invalid.throw({ typeof: typeof value });
    }

    if (spec.required && value.length === 0) {
        _.errors.empty.throw();
    }

    if (!("of" in spec)) {
        _.errors.missingOf.throw();
    }

    var itemType = spec.of || "string";
    var validator = myManager.GetType(itemType);

    for (var i = 0; i < value.length; i++) {
        try {
            validator.validate({type: itemType}, value[i]);
        } catch (e) {
            _.errors.invalidItem.throw({ item: value[i] });
        }
    }
}
module.exports.validate = validate;
